'use client'

import { resolveHeadings } from '@/admin/lexical/helpers/inPageNavigation'
import { usePageData } from '@/contexts/PageDataContext'
import type { FC } from 'react'
import { useId, useMemo } from 'react'
import type { CarouselImageGalleryBlockProps } from '../blocks/CarouselImageGallery'
import CarouselImageGalleryBlock from '../blocks/CarouselImageGallery'
import InPageNavigationBlock from '../blocks/InPageNavigationBlock'
import type { PageHeadTertiaryType } from './PageHeadTertiary'
import PageHeadTertiary from './PageHeadTertiary'
import type { VenueOverviewBlockProps } from './VenueOverviewBlock'
import { VenueOverviewBlock } from './VenueOverviewBlock'

export type VenueHeaderBlocksProps = PageHeadTertiaryType &
	CarouselImageGalleryBlockProps &
	Omit<VenueOverviewBlockProps, 'overviewId'>

export const VenueHeaderBlocks: FC<VenueHeaderBlocksProps> = ({
	title,
	images,
	introContent,
	infoContent,
	procurementUrl,
	locationLink,
	location,
	firstNationsLocation,
	projectStatus,
}) => {
	const overviewId = useId()
	const { content } = usePageData()

	const tabs = useMemo(() => {
		return [{ href: `#${overviewId}`, label: 'Overview' }, ...resolveHeadings(content)]
	}, [overviewId, content])

	return (
		<>
			<PageHeadTertiary title={title} />
			<div className="pb-6xl">
				<CarouselImageGalleryBlock images={images} />
			</div>
			<InPageNavigationBlock tabs={tabs} className="pt-sticky-nav-padding -mt-sticky-nav-padding" />
			<div className="pt-5xl pb-7xl">
				<VenueOverviewBlock
					overviewId={overviewId}
					introContent={introContent}
					infoContent={infoContent}
					procurementUrl={procurementUrl}
					locationLink={locationLink}
					location={location}
					firstNationsLocation={firstNationsLocation}
					projectStatus={projectStatus}
				/>
			</div>
		</>
	)
}
